import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

import {Input} from '@shared/Components/Form';
import {TFilter} from '../../Definitions';

type TFilterProps = {
    onUpdateKeyword: (query: string) => void;
    filter: TFilter;
    onUpdateFilter: (update: Partial<TFilter>) => void;
    className?: string;
};
export default ({onUpdateKeyword, filter, onUpdateFilter, className}: TFilterProps) => {
    const isReady = React.useRef(false);
    const [query, setQuery] = React.useState('');

    React.useEffect(() => {
        if (isReady.current) {
            onUpdateKeyword(query);
        }
        isReady.current = true;
    }, [query]);

    return (
        <div className={classNames(styles.filterList, className)}>
            <div>
                Um möglichst passende Ergebnisse angezeigt zu bekommen, geben Sie bitte einen Suchbegriff in das Suchfeld ein.
            </div>
            <div className={styles.input}>
                <Input
                    onUpdate={setQuery}
                    label="Bitte geben Sie hier Ihren Suchbegriff ein:"
                    value={query}
                />
            </div>
            <div className={styles.filter}>
                <label htmlFor="hasWertkarte">
                    <input
                        id="hasWertkarte"
                        type="checkbox"
                        checked={filter.hasWertkarte}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onUpdateFilter({hasWertkarte: e.currentTarget.checked})}
                    />Nur Geschäfte mit "Tölzer Wertkarte" anzeigen
                </label>
                <label htmlFor="isFairTrade">
                    <input
                        id="isFairTrade"
                        type="checkbox"
                        checked={filter.isFairTrade}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onUpdateFilter({isFairTrade: e.currentTarget.checked})}
                    />Nur "Fair Trade" Geschäfte anzeigen
                </label>
            </div>
        </div>
    );
}
